export default __webpack_public_path__ + "static/15_15-cdd2a261d9b87b7f4cdcb3faf8b89c09.png";